// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.description-text {
  resize: none;
  border: none Transparent;
  outline: none;
  height: 50px;
  color: #2C2B2D;
  font-family: Inter;
  font-style: normal;
  font-size: 13px;
  width: 100%;
}

.toolbar-headings {
  margin-left: 57.5px;
  justify-content: space-between;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: -0.0960779px;
  width: 170px;
}

.menu-item-text {
  color: #B2B2B2;
  font-weight: 600;
  text-align: center;
  font-family: Inter;
  font-style: normal;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: -0.083333px;
}

.active-heading {
  color: var(--theme-main-color, #055C8D);
}

.sidebar {
  mix-blend-mode: normal;
  background-color: rgba(234, 234, 234, 0.29);
  width: 200px;
  flex-basis: 200px;
  min-width: 200px;
}

.map {
  margin-right: 10px;
}

.map-row {
  min-height: 50vh;
}

.row {
  margin-left: 0px !important;
  margin-right: 0px !important;
}

.remove-button {
  margin-left: 10px;
}

.last-row {
  margin-top: 5px;
  margin-bottom: 5px;
}

.div-margin {
  margin-bottom: -10px;
}

input:disabled {
  background-color: lightgray !important;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
